/**
 * Get term options based on term count
 * @param {number} termCount - The term count (2 or 3)
 * @returns {Array} Array of term options with value and label
 */
export const getTermOptions = (termCount) => {
  if (termCount === 2) {
    return [
      { value: 1, label: "Half yearly" },
      { value: 2, label: "Final exam" },
    ];
  } else if (termCount === 3) {
    return [
      { value: 1, label: "First terminal" },
      { value: 2, label: "Second terminal" },
      { value: 3, label: "Final Result" },
    ];
  }
  return [];
};

/**
 * Get term label for a specific term value based on term count
 * @param {number} termCount - The term count (2 or 3)
 * @param {number} term - The term value (1, 2, or 3)
 * @returns {string} The label for the term
 */
export const getTermLabel = (termCount, term) => {
  const options = getTermOptions(termCount);
  const option = options.find((opt) => opt.value === parseInt(term));
  return option ? option.label : `Term ${term}`;
};

/**
 * Get term count options for dropdown
 * @returns {Array} Array of term count options
 */
export const getTermCountOptions = () => {
  return [2, 3];
};
